import { useContext, useEffect, useState } from "react";
import { ContextRegister } from "../context-api";
import Modal from "react-modal/lib/components/Modal";
import HeaderRegister from "../../../../components/header/register";

function ModalRegisterMain({ FormComponent }) {
	const { options, selectData, setSelectData, fetchID, reloadData, insert, reloadFetchFirstData, deleteItemCard } =
		useContext(ContextRegister);
	const [isOpenModalRegister, setIsOpenModalRegister] = useState(false);

	useEffect(() => {
		const handleOpen = () => {
			setIsOpenModalRegister((prevState) => !prevState); //abre o modal
		};
		window.addEventListener(`${options.ident}`, handleOpen);
		return () => {
			window.removeEventListener(`${options.ident}`, handleOpen);
		};
	}, []);

	const handleCloseModalRegister = () => {
		setIsOpenModalRegister(false);
	};

	return (
		<>
			<Modal
				isOpen={isOpenModalRegister}
				onRequestClose={handleCloseModalRegister}
				overlayClassName="react-modal-overlay"
				className="modal-content-form modal-product-resize"
				// className="modal-content-form max-h-[90%] max-w-[90%]"
				shouldCloseOnOverlayClick={false}
			>
				<div className="flex flex-col container-forms">
					<HeaderRegister
						title={options.title}
						subTitle={options.subTitle}
						handleCloseModal={handleCloseModalRegister}
					/>

					<FormComponent
						isOpenModalRegister={isOpenModalRegister}
						ident={options.ident}
						idTable={options.id}
						selectedData={selectData}
						setSelectData={setSelectData}
						fetchID={fetchID}
						reloadData={reloadData}
						reloadFetchFirstData={reloadFetchFirstData}
						insert={insert}
						deleteItemCard={deleteItemCard}
					/>
				</div>
			</Modal>
		</>
	);
}

export default ModalRegisterMain;
